import { ContentfulClientApi, createClient } from 'contentful';

import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';
import { isProd } from '@telialt/utils/src/helpers';

import { createMockClient } from './mockContentfulClientCSR';

export const getContentfulClientCSR = async (): Promise<ContentfulClientApi<undefined>> => {
    const isProdEnv = isProd();

    return checkShouldUseMocks({ shouldUseInTest: true })
        ? (createMockClient() as ContentfulClientApi<undefined>)
        : createClient({
              accessToken: ' ', // no secret token needed for CSR, we use proxied Contentful API
              host: process.env.CONTENTFUL_HOST_URL || (isProdEnv ? 'cdn.my.telia.lt' : 'cdn.test-my.telia.lt'),
              space: process.env.CONTENTFUL_SPACE_ID || (isProdEnv ? '07n1b4or2ib3' : '1dih00yo7cq3'),
              environment: process.env.CONTENTFUL_ENVIRONMENT || (isProdEnv ? 'master' : 'QA'),
          });
};
